<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM11.5303 7.21967L8.53033 4.21967C8.23744 3.92678 7.76256 3.92678 7.46967 4.21967L4.46967 7.21967C4.17678 7.51256 4.17678 7.98744 4.46967 8.28033C4.76256 8.57322 5.23744 8.57322 5.53033 8.28033L7.25 6.56066V11.25C7.25 11.6642 7.58579 12 8 12C8.41421 12 8.75 11.6642 8.75 11.25V6.56066L10.4697 8.28033C10.7626 8.57322 11.2374 8.57322 11.5303 8.28033C11.8232 7.98744 11.8232 7.51256 11.5303 7.21967Z"
    fill="currentColor"
  />
</svg>
